var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import "../models/index.js";
import * as _ from "lodash";
import { showNewPreviewScorecardExperience } from "../routes/VivaceOptIn.utils.js";
import { AnalysisOption } from "../models/exp/analysis/AnalysisGroup.js";
class AnalysisUtils {
  constructor() {
    __publicField(this, "getMetricSetVersionIdFromName", (metricSetVersionResult, metricSetVersionName) => {
      var _a, _b;
      if (!metricSetVersionName) {
        return "";
      }
      return (_b = (_a = metricSetVersionResult == null ? void 0 : metricSetVersionResult.Data.find((d) => d.VersionName === metricSetVersionName)) == null ? void 0 : _a.MetricSetId) != null ? _b : "";
    });
    __publicField(this, "getTemplateNameFromXmLLocation", (analysisTemplateNameXml) => {
      const splitNames = analysisTemplateNameXml.split("\\");
      const templateName = splitNames[splitNames.length - 1];
      return templateName.substring(0, templateName.lastIndexOf("."));
    });
    __publicField(this, "isPreviewAnalysisOption", (analysisOption) => {
      return showNewPreviewScorecardExperience() && analysisOption === AnalysisOption.PreviewAnalysis;
    });
    __publicField(this, "getTemplate", (payload) => {
      var _a, _b;
      const { analysisOption, templateName, templateNameV2DictAsync, templateFromVersionDictAsync } = payload;
      const templateDictionary = this.isPreviewAnalysisOption(analysisOption) ? templateFromVersionDictAsync : templateNameV2DictAsync;
      if (!!templateName && !!templateDictionary) {
        return (_b = (_a = templateDictionary[templateName]) == null ? void 0 : _a.data) != null ? _b : null;
      }
      return null;
    });
    /**
     * Parse the unorthodox MDL dates into date objects.
     * @param date The MDL super-special date.
     * @returns a Date object.
     */
    __publicField(this, "parseMdlDate", (date) => {
      const year = Number.parseInt(date.substr(0, 4));
      const month = Number.parseInt(date.substr(4, 2)) - 1;
      const day = Number.parseInt(date.substr(6, 2));
      return new Date(year, month, day);
    });
  }
  convertToAnalysisGroup(studyGroup) {
    const customData = JSON.parse(studyGroup[0].AdditionalContext);
    const triggerExpression = this.getTriggerExpression(studyGroup);
    const analysisGroup = {
      id: studyGroup[0].AnalysisStudyGroup.Id,
      name: studyGroup[0].AnalysisStudyGroup.Name,
      isCommitted: true,
      isRemoved: false,
      triggerExpression,
      type: !!triggerExpression ? "Triggered" : "Non Triggered",
      selectedTemplates: studyGroup.map((s) => s.BaseOnTemplate),
      sideStreamModel: customData && customData.sideStreamModel
    };
    return analysisGroup;
  }
  getTriggerExpression(studyGroup) {
    return _.chain(studyGroup[0].Scope.Filters).filter((f) => f.Operator === "CustomTriggerOn").map((f) => f.Values[0]).value()[0];
  }
  convertToAnalysisGroupCreateRequest(analysisGroup, rolloutRootStepId, workspaceId) {
    const analysisStudyRequests = _.map(
      analysisGroup.selectedTemplates,
      (t) => this.convertToAnalysisRequest(t, analysisGroup, rolloutRootStepId, workspaceId)
    );
    const analysisStudyGroupRequest = {
      AnalysisStudyGroupName: analysisGroup.name,
      AnalysisStudyCreateRequests: analysisStudyRequests
    };
    return analysisStudyGroupRequest;
  }
  convertToAnalysisRequest(templateName, analysisGroup, rolloutRootStepId, workspaceId) {
    const name = `${templateName} - ${analysisGroup.name} - Automated ${this.isTriggeredAnalysis(analysisGroup) ? "Triggered " : ""}Analysis`;
    const request = {
      AnalysisStudyDescription: name,
      AnalysisStudyName: name,
      AnalysisTemplateName: templateName,
      ExpStepId: rolloutRootStepId,
      WorkspaceId: workspaceId,
      IsOneOffAnalysis: false,
      SkipSegmentValidation: true
    };
    if (analysisGroup.sideStreamModel) {
      request.CustomData = {
        ModelJson: JSON.stringify({
          sideStreamModel: analysisGroup.sideStreamModel
        })
      };
    }
    if (analysisGroup.triggerExpression) {
      request.JobProperties = {
        TriggerFilterInfo: {
          Name: analysisGroup.name + " Trigger Expression",
          ScopeExpression: analysisGroup.triggerExpression,
          Type: "trigger"
        }
      };
    }
    return request;
  }
  isTriggeredAnalysis(analysisGroup) {
    return !!analysisGroup.triggerExpression || !!analysisGroup.sideStreamModel && (!!analysisGroup.sideStreamModel.events && analysisGroup.sideStreamModel.events.length > 0 && analysisGroup.sideStreamModel.events[0].keys.length > 0 && !!analysisGroup.sideStreamModel.events[0].keys[0].key || !!analysisGroup.sideStreamModel.customSideStreamExpression);
  }
}
const AnalysisUtilsInstance = new AnalysisUtils();
export {
  AnalysisUtils,
  AnalysisUtilsInstance
};
//# sourceMappingURL=AnalysisUtils.js.map
